import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const higgsfield = defineConnector({
  identifier: "higgsfield",
  name: "Higgsfield",
  tagLine: "AI image and video generation",
  logo,
  protocol: "http",
  tags: ["ai", "productivity"],
  defaultUrlPattern: () => "https://api\\.higgsfield\\.ai/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: `${app.config.apiKeyId}:${app.secret.apiKeySecret}`,
        scheme: "Key",
      },
    ]),
  steps: [
    {
      title: "Get API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Sign in to the [Higgsfield Console](https://console.higgsfield.ai) and generate an API credential from the dashboard. Each credential consists of a key ID and a secret.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "API key ID",
          required: true,
          target: { kind: "configuration", field: "apiKeyId" },
        },
        {
          kind: "input",
          label: "API key secret",
          required: true,
          target: { kind: "secrets", field: "apiKeySecret" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    // The API has no account endpoint; a status probe for a nonexistent
    // request returns 404 with valid credentials and 401 without.
    request: () => ({
      url: "https://api.higgsfield.ai/requests/00000000-0000-0000-0000-000000000000/status",
      expectedStatus: 404,
    }),
  },
});
